/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ImaginepayPaymentDetailModel {
  onlineAccountNumber?: string | null;
  onlinePaymentRequestID?: string | null;
  readonly displayOnlinePaymentRequestID?: string | null;
  onlineTransactionID?: string | null;
  transactionPaymentID?: string | null;
  amount?: number;
  fee?: number;
  paymentType?: string | null;
  status?: string | null;
  gateway?: string | null;
  isPriorBalance?: boolean;
  isVerified?: boolean;
  checkNumber?: string | null;
  creditCard?: string | null;
  scheduledPaymentID?: string | null;
  dataset?: string | null;
  token?: string | null;
  paymentReferenceNumber?: string | null;
}
